import React from "react";
import { api, extractApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export const PlanEditorModal = ({ editor, setEditor, plans, reload, t }) => {
  if (!editor) return null;

  const changePlan = async (p) => {
    if (p.plan_id === editor.plan_id) return;
    try {
      await api.put(`/super-admin/tenants/${editor.tenant_id}`, { plan_id: p.plan_id });
      toast.success(t("tl.planChanged", { from: editor.plan_id, to: p.plan_id }));
      setEditor(null);
      reload();
    } catch (err) {
      toast.error(extractApiError(err, t("tl.error"), t));
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={() => setEditor(null)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="plan-editor"
        className="bg-white border border-slate-200 rounded-3xl p-8 max-w-lg w-full"
      >
        <h3 className="font-sol font-semibold text-2xl mb-1">{t("tl.changePlanFor", { name: editor.name })}</h3>
        <p className="text-slate-400 text-sm mb-6">
          {t("tl.currentPlan")} <span className="text-amber-600 uppercase">{editor.plan_id}</span> · /t/{editor.slug}
        </p>
        <div className="space-y-2">
          {plans.map((p) => {
            const isCurrent = p.plan_id === editor.plan_id;
            return (
              <button
                key={p.plan_id}
                onClick={() => changePlan(p)}
                disabled={isCurrent}
                data-testid={`plan-option-${p.plan_id}`}
                className={`w-full text-left p-4 rounded-2xl border transition ${
                  isCurrent
                    ? "bg-emerald-500/10 border-emerald-500/30 cursor-default"
                    : "bg-white border-slate-200 hover:border-sol-gold/40 hover:bg-sol-gold/5 cursor-pointer"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-medium text-slate-800">{p.name}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{p.tagline}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-sol text-amber-600">
                      ${p.prices?.[editor.currency] || p.prices?.USD || 0}/mo
                    </div>
                    {isCurrent && <div className="text-[10px] uppercase text-emerald-600 mt-0.5">{t("tl.currentPlanBadge")}</div>}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
        <Button
          onClick={() => setEditor(null)}
          variant="outline"
          className="mt-6 w-full border-slate-200 text-slate-800/70 hover:bg-white shadow-sm rounded-full"
          data-testid="plan-editor-close"
        >
          {t("tl.cancel")}
        </Button>
      </div>
    </div>
  );
};

export default PlanEditorModal;
